<template>
  <div class="tracking">
    <div class="flex justify-between items-end mb-6 mdmax:flex-col mdmax:gap-4">
      <div class="w-80 mdmax:w-full">
        <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Silahkan masukan no resi</label>
        <div class="relative">
          <TextField type="text" :withIcon="true" placeholder="Masukan nomer resi" v-model="awbNumber" @enter="track()" />
          <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
            <Search />
          </div>
        </div>
      </div>
      <div v-if="isDataFound" class="mdmax:w-full">
        <LinkButton buttonText="Lihat Pesanan" :size="isMobile ? 'full' : 'regular'" linkType="internal" :url="`/order/detail/${awb.order_id}`" />
      </div>
    </div>
    <div class="bg-white flex justify-center items-center">
      <p class="text-base font-bold my-32 mdmax:px-6 mdmax:text-center" v-if="!isDataFound && !error">Silahkan memasukan nomor resi terlebih dulu</p>
      <div class="my-32" v-if="error">
        <p class="text-base font-bold text-center">Nomor resi tidak valid</p>
        <p class="text-sm text-neutral-500 text-center">Nomor resi yang kamu masukan tidak valid, silahkan masukan nomer resi lain</p>
      </div>
      <div class="flex w-full border mdmax:flex-col" v-if="isDataFound">
        <div class="bg-neutral-200 w-2/5 py-8 px-16 mdmax:w-full mdmax:px-8">
          <div class="mb-8 pb-3 shadow-border-b">
            <label class="text-xs text-neutral-500 mb-1">Nama Logistik</label>
            <p>{{ awb.service_name }}</p>
          </div>
          <div class="mb-8 pb-3 shadow-border-b">
            <label class="text-xs text-neutral-500 mb-1">Layanan</label>
            <p>{{ awb.service_package_name }}</p>
          </div>
          <div class="mb-8 pb-3 shadow-border-b">
            <label class="text-xs text-neutral-500 mb-1">No. Resi</label>
            <p>{{ awb.awb }}</p>
          </div>
          <div class="mb-8 pb-3 shadow-border-b">
            <label class="text-xs text-neutral-500 mb-1">Tanggal dikirim</label>
            <p>{{ awb.delivery_time_display }}</p>
          </div>
          <div class="mb-8 pb-3 shadow-border-b">
            <label class="text-xs text-neutral-500 mb-1">Pengirim</label>
            <p>{{ awb.sender.name }}</p>
            <p class="text-xs">{{ awb.sender.location_name }}</p>
          </div>
          <div class=" pb-3 shadow-border-b">
            <label class="text-xs text-neutral-500 mb-1">Penerima</label>
            <p>{{ awb.receiver.name }}</p>
            <p class="text-xs">{{ awb.receiver.location_name }}</p>
          </div>
        </div>
        <div class="w-3/5 p-8 mdmax:w-full">
          <div class="flex gap-5" v-for="(tracking, index) in reverseObject(awb?.tracking_infos)" :key="'tracking' + index">
            <div class="line relative">
              <span class="inline-block w-5 h-5 rounded-full  border-4  relative z-1" :class="index === 0 ? 'bg-primary-500 border-primary-100' : 'bg-neutral-500 border-neutral-300'"></span>
              <span class="absolute border-dashed border-neutral-300 h-full w-px border left-1/2 transform -translate-x-1/2 top-0 z-0"></span>
            </div>
            <div class="status mb-6">
              <p class="text-sm mb-1">{{ tracking.time_display }}</p>
              <p class="text-neutral-700 mb-1">{{ tracking.main_info }}</p>
              <p class="text-sm">{{ tracking.additional_info }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isNotEmptyError } from '@/util/form-validator'
import { mapActions, mapGetters } from 'vuex'
const CONFIG = {
  awbNumber: 'No AWB'
}
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    LinkButton: () => import(/* webpackChunkName: "form" */ '@/components/Forms/LinkButton'),
    Search: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Search')
  },
  data: () => ({
    awbNumber: null,
    errors: [],
    error: false,
    isDataFound: false
  }),
  computed: {
    ...mapGetters('common', ['awb', 'isMobile'])
  },
  methods: {
    ...mapActions('common', ['checkAwb', 'showLoading', 'hideLoading']),
    reverseObject(array) {
      let newArr = Object.assign([], array)
      return newArr && newArr.reverse()
    },
    track() {
      this.error = false
      if (!this.awbNumber) {
        this.error = true
        this.isDataFound = false
        return
      }
      this.showLoading()
      this.checkAwb({
        awbNumber: this.awbNumber
      })
        .then(() => {
          this.hideLoading()
          this.isDataFound = true
        })
        .catch(() => {
          this.hideLoading()
          this.error = true
          this.isDataFound = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.awb {
  min-height: 500px;
}
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes fadeInRight {
  from {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fadeInRight {
  from {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
.fade-in-right {
  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight;
}
</style>
